module.exports = __webpack_public_path__ + "img/coupon-bg_en.6b2241de.png";